import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts/highstock';
import * as moment from 'moment';

@Component({
  selector: 'app-industry-area-chart',
  templateUrl: './industry-area-chart.component.html',
  styleUrls: ['./industry-area-chart.component.css']
})
export class IndustryAreaChartComponent implements OnInit {

  vendorWiseIndChart: Chart;
  getVendorLoader = false;
  route = '';
  vendorWiseIndustry = [];
  vendorList = [];
  industryCount = [];
  graphPlot = false;

  userData:any = [];
  userName = null;
  userLevel = null;

  constructor(private router: Router, private _service: CommonService) { }

  ngOnInit() {

    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }
    this.getVendorWiseIndustry();
  }

  getVendorWiseIndustry(){

    this.getVendorLoader = true;
    this.route  = 'get-vendor-wise-industry';
    const token    = localStorage.getItem('userToken');

    let data = {'user_id':this.userName,'user_level':this.userLevel};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.vendorWiseIndustry = response.data;
        this.vendorList = [];
        this.industryCount = [];

        for(let vendor in this.vendorWiseIndustry) {
          this.vendorList.push(this.vendorWiseIndustry[vendor]['vendor_short_name']);
          this.industryCount.push(this.vendorWiseIndustry[vendor]['count']);
        };

        if(this.vendorList.length && this.industryCount.length){
          this.graphPlot = true;
          this.drawVendorWiseIndGraph(this.vendorList,this.industryCount);
        }else{
          this.graphPlot = false;
          this.getVendorLoader = false;
        }

      }
    });

  }

  drawVendorWiseIndGraph(vendorList, industryCount){

    let barChartLocal = new Chart({
      chart: {
        type: 'bar'
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: vendorList
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Total No of Unit Stations'
        },
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'bold'
          }
        }
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{point.y} Industries'
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: false
          }
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
            color: '#000',
            x:10
          },
        }
      },
      series: [{
        name: 'Vendor',
        data: industryCount,
        type: 'bar',
      }]
    });
    this.vendorWiseIndChart = barChartLocal;
    this.getVendorLoader = false;
  }
}
